import { NAV_GROUPS } from "@/lib/nav";

/**
 * Static, non-interactive mock of the signed-in app used on the marketing homepage.
 * The sidebar is derived from the real navigation so it always matches the product.
 */
const PREVIEW_ITEMS_PER_GROUP = 4;

const STATS = [
  { label: "Customers engaged (90d)", value: "42" },
  { label: "Contracted revenue", value: "£4.2m" },
  { label: "Open priorities", value: "18" },
  { label: "Hours committed / week", value: "26.5h" },
];

const MATRIX = [
  { title: "Important & urgent", items: ["Renewal paper for Northwind", "Escalation review"] },
  { title: "Important, not urgent", items: ["Account plan for Halden", "Q3 revenue plan"] },
  { title: "Urgent, not important", items: ["Chase PO number", "Weekly ops call"] },
  { title: "Neither", items: ["Tidy shared drive"] },
];

export function DashboardPreview() {
  return (
    <div
      aria-label="MyPriorities app preview showing customers, revenue and tasks together"
      role="img"
      className="grid gap-0 overflow-hidden rounded-md border border-border/60 bg-card/40 text-left sm:grid-cols-[190px_minmax(0,1fr)]"
    >
      <div className="hidden border-r border-border/60 bg-background/60 p-4 sm:block">
        <p className="label-caps text-[10px]">MyPriorities</p>
        <div className="mt-4 space-y-4">
          {NAV_GROUPS.map((group) => (
            <div key={group.key}>
              <div className="flex items-center gap-2 text-xs font-semibold">
                <group.icon className="size-3.5 text-primary" />
                {group.label}
              </div>
              <ul className="mt-1.5 space-y-1 pl-5">
                {group.items.slice(0, PREVIEW_ITEMS_PER_GROUP).map((navItem) => (
                  <li key={navItem.id} className="text-[11px] text-muted-foreground">
                    {navItem.label}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="p-4 sm:p-6">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <p className="label-caps text-[10px]">Priorities</p>
            <p className="text-sm font-semibold">This week</p>
          </div>
          <span className="rounded-full border border-border/60 px-2 py-0.5 text-[10px] text-muted-foreground">
            Week 34 · capacity 37.5h
          </span>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-2 lg:grid-cols-4">
          {STATS.map((stat) => (
            <div key={stat.label} className="rounded-md border border-border/60 bg-background/60 p-3">
              <p className="text-[10px] uppercase tracking-wide text-muted-foreground">
                {stat.label}
              </p>
              <p className="mt-1 text-lg font-semibold tabular-nums">{stat.value}</p>
            </div>
          ))}
        </div>

        <div className="mt-3 grid gap-2 sm:grid-cols-2">
          {MATRIX.map((quadrant) => (
            <div
              key={quadrant.title}
              className="rounded-md border border-border/60 bg-background/60 p-3"
            >
              <p className="text-[11px] font-medium">{quadrant.title}</p>
              <ul className="mt-2 space-y-1.5">
                {quadrant.items.map((task) => (
                  <li
                    key={task}
                    className="flex items-center gap-2 text-[11px] text-muted-foreground"
                  >
                    <span className="size-1.5 rounded-full bg-primary/70" />
                    {task}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
